import { css } from 'lit';

// language=CSS
export const styles = css`
    :host {
        height: calc(100% - 2 * var(--padding-default));
        box-shadow: 2px 3px 6px #B4B4B4;
        border: 1px solid #B4B4B4;
        font-size: var(--font-size-large);
        color: var(--color-primary);
        padding: var(--padding-default) calc(var(--padding-default) * 2);
    }
`;
